export const API_DATE_TIME_FORMAT: string = 'YYYY-MM-DD HH:mm:ss';
/**
 * The server stores all of its timestamps in Eastern timezone. This is our default timezone to parse from.
 */
export const API_TIMEZONE: string = 'America/New_York';
export const DISPLAY_DATE_FORMAT: string = 'MMM D, YYYY';
export const DISPLAY_TIME_FORMAT: string = 'h:mm:ss A';
export const DISPLAY_DATE_TIME_FORMAT: string = 'MMM D, YYYY h:mm:ss A';
export const NGB_DATE_FORMAT: string = 'YYYY-MM-DD';
